import { Switch } from "antd";

const SwitchCellRenderer = (props: any) => {
  const {
    data,
    context: { setStatusData },
  } = props;

  return (
    <div>
      <Switch
        disabled={data?.role_id === 1 || data?.id==0 ? true : false}
      checked={data?.status == 1}
      onClick={() => {
        setStatusData({ id: data?.id, status: Number(!data?.status) });
      }}
      />
    </div>
  );
};
export default SwitchCellRenderer;
